import snapshotSignResponseService from "@/services/mrfiktiv/services/snapshot-sign-response.service";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { FetchStrategy, SharedContentDocument, safeFetch } from "../SharedContentFetchStrategy";
import { PopulatedSnapshotSignRequest } from "@/models/populated-snapshot-sign-request.entity";

// This fetch strategy handles shared refs of type SNAPSHOT_SIGN_REQUEST
export class SnapshotSignResponseFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === BackendResourceEnum.SNAPSHOT_SIGN_REQUEST;
  }

  fetch(partnerId: string, refId: string, sct: string): Promise<SharedContentDocument> {
    return safeFetch(refId, BackendResourceEnum.SNAPSHOT_SIGN_REQUEST, async () => {
      const document = await snapshotSignResponseService.getDocumentBySharedAccessToken(partnerId, refId, sct);

      const mapped = new PopulatedSnapshotSignRequest(document);

      return mapped;
    });
  }
}
